var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("这是表格封装演示")]),_c('Tables',{attrs:{"tableData":_vm.tableDatas}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }